import { useTranslation } from 'react-i18next';

import { useFocus } from 'contexts/FocusContext';
import { Text } from 'components/LoginComponents';
import { Body, Dialog, Header, Content } from 'components/Modal';
import RetrySearchForm from 'components/RetrySearchForm';
import { CustomText } from 'components/CustomText';
import FocusManager from 'components/FocusManager';
import { GlobalConfig } from 'interfaces/GlobalConfig.interface';

interface ReLoginModalProps {
  globalConfig: GlobalConfig;
}

const ReLoginModal = ({ globalConfig }: ReLoginModalProps): JSX.Element => {
  const { t } = useTranslation();
  const { shouldFocus } = useFocus();

  const configs = globalConfig.config;
  const { merchantCustom } = configs;

  return (
    <FocusManager shouldFocus={shouldFocus}>
      <Dialog>
        <Header>{t('NO_INFORMATION_AVAILABLE')}</Header>
        <Body>
          <Content>
            <CustomText
              as={Text}
              text={
                merchantCustom.noInfoDisplayMessage ||
                t('NO_INFORMATION_MESSAGE_1')
              }
            />
            <RetrySearchForm
              messageSearchForm={merchantCustom.noInfoDisplayMessage2}
            />
          </Content>
        </Body>
      </Dialog>
    </FocusManager>
  );
};

export default ReLoginModal;
